import React, { useEffect } from 'react';
import { Checkbox, withStyles } from '@material-ui/core';
import { TextFieldEditor } from '@dataGrid/components/cellEditors';

const styles = (theme) => ({
  container: {
    padding: '8px 0',
    fontSize: theme.textFontSize,
    color: theme.gridTextColor
  },
  checkbox: {
    padding: 0,
    marginRight: 8,
    color: theme.iconColor
  },
  checkboxLabel: {
    fontWeight: 500
  },
  extraInputContainer: {
    paddingTop: 4,
    paddingLeft: 24
  },
  extraInfo: {
    fontWeight: 400,
    paddingBottom: 6
  },
  dropdown: {
    fontWeight: 500
  },
  dropdownLabel: {
    marginRight: 8
  },
  errorColor: {
    marginTop: 4,
    color: theme.ErrorMessageColor
  }
});

const AdvancedSettingsTab = ({
  classes,
  isMergeExtraRoutes,
  mergedExtraRouteName,
  onFormDataChange,
  extraRouteError
}) => {
  useEffect(() => {
    if (isMergeExtraRoutes) {
      onFormDataChange('mergedExtraRouteName', mergedExtraRouteName); // checking validation for first time
    }
  }, [isMergeExtraRoutes]);

  const handleChange = (name) => (event) => {
    if (name === 'mergedExtraRouteName') {
      onFormDataChange(name, event);
    } else if (name === 'isMergeExtraRoutes') {
      onFormDataChange(name, event.target.checked);
    }
  };

  return (
    <div className={classes.container}>
      <Checkbox
        color="primary"
        className={classes.checkbox}
        checked={isMergeExtraRoutes}
        onChange={handleChange('isMergeExtraRoutes')}
      />
      <span className={classes.checkboxLabel}>Disable extra route creation</span>
      {isMergeExtraRoutes && (
        <div className={classes.extraInputContainer}>
          <div className={classes.extraInfo}>
            {`Optymizer will use trailer input for route creation, all extra shipments will be
                    moved to route named '${mergedExtraRouteName}'.`}
          </div>
          <div className={classes.dropdown}>
            <span className={classes.dropdownLabel}>Route Name:</span>
            <TextFieldEditor
              value={mergedExtraRouteName}
              onChange={handleChange('mergedExtraRouteName')}
            />
          </div>
          {extraRouteError && <div className={classes.errorColor}>{extraRouteError}</div>}
        </div>
      )}
    </div>
  );
};

export default withStyles(styles)(AdvancedSettingsTab);
